import { ErrorBoundary } from '@dixa/lib-shared-habla';
import { lazy, Suspense } from 'react';

import { AiDraftActivityLog } from 'components/activityLog/components/aiDraftActivityLog';
import { SourceConversations } from 'components/sourceConversations';
import { useNotifications } from 'hooks/useNotifications';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useNavigatePrompt } from 'utils/url/useNavigatePrompt';

import { KnowledgeErrorPlaceholder } from './components/errorPlaceholder';
import { KnowledgeLoading } from './components/loading';
import { subscribeToAiDraftEvents } from './utils/subscribeToAiDraftEvents';
import { subscribeToAiSettingsEvents } from './utils/subscribeToAiSettingsEvents';

const ManagementRoutes = lazy(() => import('lib-knowledge-management'));

export const KnowledgeManagementRoutes = (): JSX.Element => {
  const notify = useNotifications();
  const flags = useFeatureFlag([
    'knowledge-articles-ai-auto-translations',
    'smart-article-create-multi-conversation',
  ]);

  return (
    <ErrorBoundary fallback={<KnowledgeErrorPlaceholder />}>
      <Suspense fallback={<KnowledgeLoading />}>
        <ManagementRoutes
          notify={notify}
          featureFlags={{
            aiAutoTranslation: flags.knowledgeArticlesAiAutoTranslations,
            smartArticleCreateMultiConversation:
              flags.smartArticleCreateMultiConversation,
          }}
          renderSourceConversations={(conversations) => (
            <SourceConversations conversations={conversations} />
          )}
          subscribeToAiDraftEvents={subscribeToAiDraftEvents}
          subscribeToAiSettingsEvents={subscribeToAiSettingsEvents}
          useNavigatePrompt={useNavigatePrompt}
          renderAiDraftActivityLog={({ aiDraftId, revision }) => (
            <AiDraftActivityLog aiDraftId={aiDraftId} revision={revision} />
          )}
        />
      </Suspense>
    </ErrorBoundary>
  );
};
